import {createSlice} from "@reduxjs/toolkit";
import {activateTheme, fetchActiveTheme, restoreTheme} from "./themeThunks";

export const activeThemeSlice = createSlice({
    name: 'activeTheme',
    initialState: {
        activeTheme: null,
        loading: true,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(activateTheme.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(activateTheme.fulfilled, (state, action) => {
                state.loading = false;
                state.activeTheme = action.payload.theme;
            })
            .addCase(activateTheme.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })


            .addCase(fetchActiveTheme.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchActiveTheme.fulfilled, (state, action) => {
                state.loading = false;
                state.activeTheme = action.payload; // Assuming the payload contains the active theme slug
            })
            .addCase(fetchActiveTheme.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })


            .addCase(restoreTheme.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(restoreTheme.fulfilled, (state, action) => {
                state.loading = false;
                state.activeTheme = action.payload.theme; // Assuming the payload contains the restored theme
            })
            .addCase(restoreTheme.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    }
})

export default activeThemeSlice.reducer;